import {Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import {NgbAlert} from "@ng-bootstrap/ng-bootstrap";
import {AuthService, PasswordResetResult} from "../auth.service";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import {PasswordFieldState} from "../../common/password-field-state";
import {AlertComponent} from "../../common/alert/alert.component";
import {AlertService} from "../../common/alert/alert.service";

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    imports: [
        ReactiveFormsModule,
        NgIf,
        RouterLink,
        AlertComponent
    ],
    styleUrls: ['./password-reset.component.css'],
    providers: [AlertService]
})
export class PasswordResetComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];
    private formBuilder = new FormBuilder().nonNullable
    private token: string = ''

    private email = this.formBuilder.control(
        {value: "", disabled: true},
        {validators: [Validators.email]}
    )
    private password = this.formBuilder.control(
        "",
        {validators: Validators.minLength(6)}
    )
    private confirmPassword = this.formBuilder.control("")

    resetForm = new FormGroup(
        {
            email: this.email,
            password: this.password,
            confirmPassword: this.confirmPassword,
        },
        {validators: passwordMatchValidator}
    );
    passwordState = new PasswordFieldState()
    isLoading = false;
    result: string | null = null;

    constructor(private authService: AuthService, private route: ActivatedRoute, private alertService: AlertService) {

    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.route.params.subscribe(params => {
                this.email.setValue(params["email"])
                this.token = params["token"]
            })
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    submit() {
        this.clearState();
        if (this.resetForm.invalid) {
            if (this.password.errors?.["minlength"] != null) {
                this.alertService.showAlert('warning', 'Password is too short');
            } else if (this.resetForm.errors?.["passwordMatch"] != null) {
                this.alertService.showAlert('warning', 'Passwords do not match');
            }
        } else {
            this.isLoading = true;
            this.subscriptions.push(
                this.authService.resetPassword(this.email.value, this.password.value, this.token)
                    .subscribe(result => {
                        this.clearState();
                        switch (result) {
                            case PasswordResetResult.Success:
                                this.result = "success";
                                break
                            case PasswordResetResult.TokenExpired:
                                this.result = "token_expired"
                                break;
                            case PasswordResetResult.Error:
                                this.result = "error"
                                break
                        }
                    })
            );
        }
    }

    private clearState() {
        this.alertService.clearAlerts();
        this.isLoading = false;
    }
}

const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password')?.value;
    const confirmation = control.get('confirmPassword')?.value;

    return password == confirmation ? null : {passwordMatch: true};
};
